<button class="btn" [ngClass]="['variant-' + variant]" [type]="type" [disabled]="disabled">
  <ng-content></ng-content>
</button>
